import React from 'react';
import PropTypes from 'prop-types';

import { withRouter } from 'core/libs/router';

import SearchInput from 'core/components/SearchInput';
import withTheme from 'core/hocs/withTheme';

import themePropTypes from 'core/utils/prop-types/theme';
import { buildSearchLink } from 'core/utils/url-helper';

function onSubmit(history, prefix, event) {
  event.preventDefault();
  history.push(buildSearchLink(prefix, event.target.query.value));
}


function Bouesque(props, context) {
  const {
    theme: {
      controls: {
        bouesque: {
          const: {
            size,
          },
        },
      },
    },
    history,
    match, // eslint-disable-line
    location, // eslint-disable-line
    staticContext, // eslint-disable-line
    ...inputProps
  } = props;


  const { mediaUrlPrefix } = context;

  return (
    <form onSubmit={onSubmit.bind(this, history, mediaUrlPrefix)}>
      <SearchInput
        name='query'
        size={size}
        {...inputProps}
      />
    </form>
  );
}

Bouesque.propTypes = {
  /** @ignore */
  history: PropTypes.object,
  /** @ignore */
  theme: themePropTypes(`
    {
      controls: {
        bouesque: {
          const: {
            size,
          },
        },
      },
    },
  `),
};

Bouesque.contextTypes = {
  mediaUrlPrefix: PropTypes.string,
};

const BouesqueWithHOCs = withRouter(withTheme(Bouesque));
BouesqueWithHOCs.displayName = 'Bouesque';

export { Bouesque as StorybookComponent };
export default BouesqueWithHOCs;
